import { render, staticRenderFns } from "./BtnInserirParcelamento.vue?vue&type=template&id=7508c43d&"
import script from "./BtnInserirParcelamento.vue?vue&type=script&lang=js&"
export * from "./BtnInserirParcelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports